export type PaginationItem = number | 'ellipsis';

export function buildPaginationItems(current: number, total: number): PaginationItem[] {
    if (total <= 0) {
        return [];
    }

    if (total <= 5) {
        return Array.from({ length: total }, (_, index) => index + 1);
    }

    const pages = new Set<number>([1, total, current]);
    if (current - 1 >= 1) {
        pages.add(current - 1);
    }
    if (current + 1 <= total) {
        pages.add(current + 1);
    }

    const sorted = [...pages].sort((a, b) => a - b);
    const items: PaginationItem[] = [];

    sorted.forEach((page, index) => {
        if (index > 0 && page - sorted[index - 1] > 1) {
            items.push('ellipsis');
        }
        items.push(page);
    });

    return items;
}
